import { ChangeDetectorRef, Component, forwardRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';
import { FormControlTemplatesService } from 'src/app/templates/form-control-templates.service';

@Component({
  selector: 'fpx-radio-button',
  templateUrl: './fpx-radio-button.component.html',
  styleUrls: ['./fpx-radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxRadioButtonComponent),
      multi: true
    }
  ]
})
export class FpxRadioButtonComponent extends BaseFpxControlComponent {
  @Input() direction: "column" | "row" = "row";
  @Input() labelPosition: "after" | "before" = "after";

  constructor(
    controlContainer: ControlContainer,
    changeDetectorRef: ChangeDetectorRef,
    private _fromControlTemplateService: FormControlTemplatesService
  ) {
    super(controlContainer, changeDetectorRef)
  }

  getTemplate(ngTemplateName: string): TemplateRef<any> {
    let tmplt = this._fromControlTemplateService.getTemplate(ngTemplateName);
    return tmplt;
  }
}
